<template>
  <section class="c_event_cards c_wrapper">
    <EventCard
      v-for="(event, index) in events"
      :key="index"
      :event-type="event.eventType[0]?.title"
      :eyebrow-text="event.eyebrowText"
      :event-title="event.eventTitle"
      :event-image="[event.eventImage[0]?.filterLandscape]"
      :event-description="event.eventDescription"
      :card-style="event.cardStyle"
      :primary-button="{
        primaryButtonAsset: event.primaryButtonAsset,
        primaryButtonEntry: event.primaryButtonEntry,
        primaryButtonCustomUrl: event.primaryButtonCustomUrl,
        primaryButtonText: event.primaryButtonText,
      }"
      :secondary-button="{
        secondaryButtonAsset: event.secondaryButtonAsset,
        secondaryButtonEntry: event.secondaryButtonEntry,
        secondaryButtonCustomUrl: event.secondaryButtonCustomUrl,
        secondaryButtonText: event.secondaryButtonText,
      }"
    />
  </section>
</template>

<script>
import EventCard from './EventCard.vue';
export default {
  props: {
    events: Array,
    sectionTitle: String,
  },
  components: {
    EventCard,
  },
};
</script>

<style lang="scss">
.c_event_cards {
  $self: &;
  padding-top: px_to_rem(40);
  padding-bottom: px_to_rem(40);
  @include mq($mq_md_to_lg) {
    padding-top: px_to_rem(70);
    padding-bottom: px_to_rem(70);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: px_to_rem(25);
  }
}
</style>
